// Greeting-name validation — never show undefined/null/emails/phones/symbols in greetings.
const INVALID_WORDS = /^(undefined|null|nan|n\/a|none|test|user)$/i;
const MAX_NAME_LEN = 30;

export function displayName(raw, { allowDigits = false } = {}) {
  if (typeof raw !== "string") return null;
  let s = raw.trim().replace(/\s+/g, " ");
  if (!s) return null;
  if (INVALID_WORDS.test(s)) return null;
  if (s.includes("@")) return null; // email address
  if (/(https?:\/\/|www\.)/i.test(s)) return null; // URL
  if (/\d{7,}/.test(s.replace(/[\s-]/g, ""))) return null; // phone-like number
  const allowed = allowDigits
    ? /^[\u0600-\u06FF\u0750-\u077FA-Za-z0-9\s.\-'’&()]+$/
    : /^[\u0600-\u06FF\u0750-\u077FA-Za-z\s.\-'’]+$/;
  if (!allowed.test(s)) return null; // broken variables / symbols
  if (!/[\u0600-\u06FFA-Za-z]/.test(s)) return null; // must contain letters
  if (s.length > MAX_NAME_LEN) s = s.slice(0, MAX_NAME_LEN).trimEnd() + "…";
  return s;
}

// Exact greeting logic:
// - Guest / loading profile -> neutral greeting (no name, no placeholders)
// - Customer -> validated personal name
// - Merchant -> validated business name (falls back to personal name, then neutral)
export function greet(user, lang, { business = false } = {}) {
  const neutral = lang === "ar" ? "أهلاً بك" : "Welcome";
  if (!user) return neutral;
  const raw = business ? user.business_name || user.name : user.name;
  const n = displayName(raw, { allowDigits: business });
  if (!n) return neutral;
  return lang === "ar" ? `أهلاً بك، ${n}` : `Welcome, ${n}`;
}
